import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequestFeedback } from '../../../../lib/hooks';
import { PageLayout } from '../../../../lib/shell/PageLayout/PageLayout';
import { ClientsBreadcrumb } from '../components/ClientsBreadcrumb';
import { AddClientConfigForm } from '../components/forms/AddClientConfigForm';
import { CreateClientConfigDto } from '../dtos/CreateClientConfigDto';
import { useClientConfigApi } from '../hooks/useClientConfigApi';
import { useClientConfigForm } from '../hooks/useClientConfigForm';

export const AddClientConfigPage: FC = () => {
	const { insert, get_last_id } = useClientConfigApi();
	const navigate = useNavigate();
	const { form_state, show_errors, change_field_value } = useClientConfigForm();

	function on_submit() {
		show_errors();

		if (!form_state.valid) {
			return;
		}

		const dto: CreateClientConfigDto = {
			c_code: form_state.value.c_code.trim(),
			id: form_state.value.id.trim(),
			initials: form_state.value.initials.trim(),
			name: form_state.value.name.trim(),
			unlimited: form_state.value.unlimited,
			partner: false,
			sale: true,
			profile: 1,
			search_ai: form_state.value.search_ai,
			copyright: form_state.value.copyright,
			allContentView: form_state.value.allContentView,
			monthlyQuestionLimit: Number(form_state.value.monthlyQuestionLimit),
			enableDomainAccess: form_state.value.enableDomainAccess,
			enableChatAttachments: form_state.value.enableChatAttachments,
		};

		insert.send(dto);
	}

	useRequestFeedback(insert.result, insert.error);

	useEffect(() => {
		if (insert.result) {
			navigate(`/plataforma/clientes/${form_state.value.id}`, { replace: true });
		}
	}, [insert.result]);

	useEffect(() => {
		get_last_id.get();
	}, []);

	useEffect(() => {
		if (get_last_id.result) {
			const last_id = Number(String(get_last_id.result.last_id));
			if (last_id) {
				change_field_value('id', String(last_id + 1));
			}
		}
	}, [get_last_id.result]);

	return (
		<PageLayout {...{ title: 'Novo Cliente', breadcrumb: () => <ClientsBreadcrumb />, browser_back: true }}>
			<AddClientConfigForm {...{ change_field_value, form_state, loading: insert.loading, on_submit }} />
		</PageLayout>
	);
};
